import { render } from "./ShipmentPage.vue?vue&type=template&id=1687ec25&scoped=true&ts=true"
import script from "./ShipmentPage.vue?vue&type=script&lang=ts"
export * from "./ShipmentPage.vue?vue&type=script&lang=ts"

import "./ShipmentPage.vue?vue&type=style&index=0&id=1687ec25&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1687ec25"]])

export default __exports__